<template>
  <div class="Header">
    <div class="h-t">
      <div class="item">
        <div class="item-l">企校云-岗位招聘</div>
        <div class="item-r">
          <!-- <span><img src="../assets/image/stel.png" style="width:21px;height:21px;" />24小时服务热线：0571-88026052</span>
          <span style="cursor:pointer" @click="setHomePage">设为首页</span>
          <span style="color:#ac8125;font-weight:bold;">|</span>
          <span style="cursor:pointer" @click="AddFavorite">加入收藏</span> -->
        </div>
      </div>
    </div>
    <!-- <div class="h-b">
      <div class="item">
        <div class="item-l">
          <img src="../assets/image/wbyx.png" />
        </div>
        <div class="item-r">
          <el-menu :default-active="activeIndex" router class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item index="/">首页/Home</el-menu-item>
            <el-menu-item index="/ContactUs" >联系我们</el-menu-item>
          </el-menu>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      proList: [],
      activeIndex: '/',
    };
  },
  components: {},
  created() {},
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
    // setTimeout(this.winMove, 1000);
    this.activeIndex = this.$route.path;
  },
  computed: {
    isToken() {
      return this.$store.state.token;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
  },
  methods: {
    AddFavorite() {
      try {
        window.external.addFavorite(document.URL, document.title);
      } catch (e) {
        try {
          window.sidebar.addPanel(document.title, document.URL, '');
        } catch (e) {
          alert('加入收藏失败，请使用Ctrl+D进行添加,或手动在浏览器里进行设置.');
        }
      }
    },

    setHomePage() {
      var url = window.location.href;
      var o = arguments.length > 0 ? arguments[0] : document.body;
      try {
        o.style.behavior = 'url(#default#homepage)';
        o.setHomePage(url);
      } catch (e) {
        if (window.sidebar) {
          if (window.netscape) {
            try {
              netscape.security.PrivilegeManager.enablePrivilege('UniversalXPConnect');
            } catch (e) {
              alert(
                "抱歉！您的浏览器不支持直接设为首页。请在浏览器地址栏输入'about:config'并回车然后将[signed.applets.codebase_principal_support]设置为'true'，点击'加入收藏'后忽略安全提示，即可设置成功。"
              );
            }
            var prefs = Components.classes['@mozilla.org/preferences-service;1'].getService(Components.interfaces.nsIPrefBranch);
            prefs.setCharPref('browser.startup.homepage', url);
          }
        } else {
          alert('抱歉！您的浏览器不支持直接设为首页。');
        }
      }
    },
    handLoginClick() {
      this.$router.push({
        path: '/login',
      });
    },
    handleCommand(com) {
      if (com == 'logOut') {
        this.handleBack();
      }
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      this.activeIndex = key;
    },
    handleBack() {
      this.$store.commit('setUserInfo', null);
      this.$store.commit('setToken', null);
    },
  },
};
</script>
<style lang="less" scoped>
.Header {
  // background: #b75d5d;
  width: 100%;
  // height: 120px;
  min-width: 1280px;
  border-bottom: 1px solid #ccc;
  position: fixed;
  top:0;
  z-index: 10;
  .fixed-box {
    text-align: center;
    position: fixed;
    width: 72px;
    height: 120px;
    z-index: 999;
    top: 300px;
    right: 20px;
    background-image: url(/img/try_icon.24ae1227.png);
    background-position: top;
    background-size: 72px 120px;
    background-repeat: no-repeat;
    background-position: center;
    opacity: 0.8;
    color: #fefefe;
    writing-mode: tb;
    line-height: 74px;
    letter-spacing: 4px;
    cursor: pointer;
    box-shadow: 0 0 12px 1px #7da7d1 inset;
  }
  .fixed-box:hover {
    box-shadow: 0 0 12px 1px #2581dc inset;
  }
  .h-t {
    height: 42px;
    background: #111111;
    color: #d9d9d9;
    font-size: 12px;
    .item {
      width: 1200px;
      line-height: 42px;
      display: flex;
      margin: 0 auto;
      position: relative;
      .item-l {
        width: 600px;
        text-align: left;
      }
      .item-r {
        text-align: right;
        width: 600px;
        span:first-child {
          margin-right: 32px;
          img {
            width: 21px;
            height: 21px;
            margin-right: 4px;
            vertical-align: middle;
          }
        }
        span {
          margin-right: 8px;
        }
      }
    }
  }
  .h-b {
    height: 88px;
    background: #ffffff;
    .item {
      width: 1200px;
      // line-height: 88px;
      height: 88px;
      display: flex;
      margin: 0 auto;
      .item-l {
        width: 45%;
        // line-height: 88px;
        text-align: left;
        display: flex;
        img {
          width: 150px;
          height: 64px;
          margin-top: 12px;
          // vertical-align: middle;
        }
        div {
          padding-left: 16px;
          p:first-child {
            font-size: 24px;
            margin-top: 20px;
            letter-spacing: 8px;
          }
          p {
            font-size: 12px;
            letter-spacing: 3px;
          }
        }
      }
      .item-r {
        text-align: right;
        width: 55%;
        /deep/.el-menu {
          height: 100%;
          border-bottom: 0;
          .el-menu-item {
            height: 88px;
            font-size: 18px;
            line-height: 88px;
            padding: 0 31px;
            color: #666;
            border: 0;
          }
        }
      }
    }
  }
}
.h-box {
  width: 1280px;
  height: inherit;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;

  .h-l {
    height: inherit;
    width: 50%;
    text-align: left;
  }
  .h-r {
    text-align: right;
    height: inherit;
    width: 50%;
    position: relative;
  }
}
/deep/.el-menu.el-menu--horizontal {
  border: 0;
}
/deep/.el-menu--horizontal > .el-menu-item.is-active {
  border: 0;
  background: #307fbb !important;
  color: #fefefe !important;
}
/deep/.el-menu-item:hover {
  color: #307fbb !important;
}
</style>
